import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Buttons/Button';
import IconWithText from '../Icons/IconWithText';

const CommentLikeButton = ({ likes, liked, onClick }) => {
  let likeBtnText;
  const numberOfLikes = likes.length;
  if (numberOfLikes > 0) {
    likeBtnText = `${numberOfLikes} Likes`;

    if (numberOfLikes === 1) {
      likeBtnText = `${numberOfLikes} Like`;
    }
  } else {
    likeBtnText = 'Like';
  }

  const likeBtnClass = classNames('like-btn', 'grey-link', 'h5', {
    liked,
  });

  return (
    <Button onClick={onClick} classes={likeBtnClass} faux>
      <IconWithText name="thumb-up" size="s">{likeBtnText}</IconWithText>
    </Button>
  );
};

CommentLikeButton.propTypes = {
  likes: PropTypes.array.isRequired,
  liked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default CommentLikeButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/CommentLikeButton.js